// extracted by mini-css-extract-plugin
export default {"wrapper":"Arrow_wrapper__Jv8R-"};